import { useAuth } from 'react-oidc-context';

export function useApiWithAuth() {
  const auth = useAuth();

  const fetchWithAuth = async (url: string, options: RequestInit = {}) => {
    const token = auth?.user?.id_token; // keep id_token if your authorizer is set for it
    if (!token) {
      throw new Error('No auth token found. Please sign in again.');
    }

    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    };

    return fetch(url, { ...options, headers });
  };

  return fetchWithAuth;
}